import { render } from "./QuizInputs.vue?vue&type=template&id=e5996dec&scoped=true"
import script from "./QuizInputs.vue?vue&type=script&lang=js"
export * from "./QuizInputs.vue?vue&type=script&lang=js"

import "./QuizInputs.vue?vue&type=style&index=0&id=e5996dec&scoped=true&lang=css"

import exportComponent from "/home/debian/quiz-anatomie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5996dec"]])

export default __exports__